// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageInformation_mainContainer__CwPhE{
    
    padding: 30px;
    font-family: Gilroy, sans-serif;
    color:white;
}
.PageInformation_header__ZlHBf{
    font-size: 40px;
    font-weight: 1000;
    margin-bottom: 40px;

}
.PageInformation_main__VWSCs{
    background-color: #0f1721;
    padding: 10px;
    font-size: 20px;
    font-weight: 400;
    overflow-wrap: break-word;
    border-radius: 10px;
    line-height: 1.5; /* Задаем отступ между строками (можете настроить по своему усмотрению) */

}
@media (max-width:1000px) {
    .PageInformation_mainContainer__CwPhE{
        margin-bottom: 50px;
        margin-left: 0;
    }

}`, "",{"version":3,"sources":["webpack://./src/Pages/PageInformation/PageInformation.module.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;IACb,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;;AAEvB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB,EAAE,yEAAyE;;AAE/F;AACA;IACI;QACI,mBAAmB;QACnB,cAAc;IAClB;;AAEJ","sourcesContent":[".mainContainer{\n    \n    padding: 30px;\n    font-family: Gilroy, sans-serif;\n    color:white;\n}\n.header{\n    font-size: 40px;\n    font-weight: 1000;\n    margin-bottom: 40px;\n\n}\n.main{\n    background-color: #0f1721;\n    padding: 10px;\n    font-size: 20px;\n    font-weight: 400;\n    overflow-wrap: break-word;\n    border-radius: 10px;\n    line-height: 1.5; /* Задаем отступ между строками (можете настроить по своему усмотрению) */\n\n}\n@media (max-width:1000px) {\n    .mainContainer{\n        margin-bottom: 50px;\n        margin-left: 0;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `PageInformation_mainContainer__CwPhE`,
	"header": `PageInformation_header__ZlHBf`,
	"main": `PageInformation_main__VWSCs`
};
export default ___CSS_LOADER_EXPORT___;
